import React from "react";

/**
 * Renders an editorial eyebrow.
 * If `num` is provided: ● 01 · CATEGORIA
 * Otherwise:            ● CATEGORIA
 */
const SectionEyebrow = ({ children, num, className = "", testId }) => (
  <span className={`eyebrow ${className}`} data-testid={testId}>
    {num && (
      <>
        <span className="eyebrow-num">{num}</span>
        <span className="eyebrow-sep" aria-hidden="true">·</span>
      </>
    )}
    {children}
  </span>
);

export default SectionEyebrow;
